import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

export default class Logging {
	public static init () {
		Logging.info('LOGGING ENABLED');
		if (process.env.VUE_APP_ENVIRONMENT !== 'development') {
			Sentry.init({
				Vue,
				dsn: 'https://efcfa632a3aa43b49633fcfa829b4c09@o517125.ingest.sentry.io/5624465',
				integrations: [new Integrations.BrowserTracing()],
				tracesSampleRate: 0.2,
				ignoreErrors: [
					'ResizeObserver loop limit exceeded'
				]
			});
		}
	}

	public static debug (...args: any[]) {
		if (process.env.VUE_APP_ENVIRONMENT === 'development') {
			Logging._log.call(this, '[DEBUG]', args);
		}
	}

	public static log (...args: any[]) {
		if (process.env.VUE_APP_ENVIRONMENT === 'development') {
			Logging._log.call(this, '[LOG]', args);
		}
	}

	public static info (...args: any[]) {
		Logging._log.call(this, '[INFO]', args);
	}

	public static warn (warn, ...args: any[]) {
		console.warn(warn, args);
	}

	public static error (error, ...args: any[]) {
		console.error(error, args);
	}

	private static _log (type: string, args: any[]) {
		if (typeof console === 'object') {
			console.log(type, ...args);
		}
	}
}
